<template>
  <div>
    <CHeaderNav
      v-if="
        currentUserRole !== Role.systemCandidate &&
        currentUserRole !== Role.customerCandidate &&
        (currentUserRole !== Role.customerUser || isEducationalInstitute)
      "
      class="d-md-down-none mr-auto ml-3 d-flex align-items-center"
      style="max-height: 45px; min-height: 45px"
    >
      <CHeaderNavItem v-for="item in getAcl" :key="item.menu">
        <CDropdown
          v-if="item.menu_items && item.menu_items.length"
          class="nav-dropdown px-2 pt-2"
          add-menu-classes="pt-0"
          :ref="item.menu"
          :click="toggleClass(item.menu)"
          v-on:mouseover.native="show(item.menu)"
          v-on:mouseleave.native="hide(item.menu)"
        >
          <template #toggler-content>
            <div class="d-flex align-items-center text">
              <em :class="`${getMenuIcon(item.menu)} mr-1`"></em>
              <span class="ml-2 header-nav">{{ item.label }}</span>
            </div>
          </template>
          <div v-if="item.menu_items.length">
            <div v-for="sub_menu in item.menu_items" :key="sub_menu.item">
              <CDropdown
                v-if="sub_menu.menu_items.length"
                addTogglerClasses="sub-dropdown-item"
                placement="right-start"
                :ref="`sub_${sub_menu.menu}`"
                v-on:mouseover.native="show(`sub_${sub_menu.menu}`)"
                v-on:mouseleave.native="hide(`sub_${sub_menu.menu}`)"
              >
                <template #toggler-content>
                  <div class="d-flex align-items-center">
                    <em :class="`${getSubMenuIcon(sub_menu.menu)} mr-1`"></em>
                    <span>{{ sub_menu.label }}</span>
                  </div>
                </template>
                <CDropdownItem
                  v-for="sub_sub_menu in sub_menu.menu_items"
                  :key="sub_sub_menu.item"
                  :to="getPathForMenu(sub_sub_menu.menu, item)"
                  :click="toggleClass('config')"
                >
                  <em :class="`${getSubMenuIcon(sub_sub_menu.menu)} mr-2`"></em>
                  {{ sub_sub_menu.label }}
                </CDropdownItem>
              </CDropdown>
              <CDropdownItem v-else :to="getPathForMenu(sub_menu.menu, item)">
                <em :class="`${getSubMenuIcon(sub_menu.menu)} mr-2`"></em>
                {{ sub_menu.label }}
              </CDropdownItem>
            </div>
          </div>
        </CDropdown>
        <div class="d-flex align-items-center px-2 pt-2 text" v-else>
          <CNavItem :to="getPathForMenu(item.menu, item)">
            <template>
              <div class="text-black">
                <em class="fas fa-list-alt"></em>
                <span class="header-nav ml-2">{{ item.label }}</span>
              </div>
            </template>
          </CNavItem>
        </div>
      </CHeaderNavItem>
    </CHeaderNav>
    <PartnerEdit
      v-if="partnerEditModal.isShowPopup"
      :partnerDetail="partnerEditModal.data"
      :isShowPopup="partnerEditModal.isShowPopup"
      @modalCallBack="partnerModalCallBack"
    />
  </div>
</template>

<script>
import { Role, TFW_CANDIDATE_URL, getLocalOrgDetail } from "@/helpers/helper";
import { mapGetters, mapActions } from "vuex";
import PartnerEdit from "@/containers/Partner/EditPartner";
import { CDropdownItem } from "@coreui/vue";

export default {
  name: "TheDynamicNavHeaders",
  components: {
    PartnerEdit,
  },
  data() {
    return {
      Role,
      getLocalOrgDetail,
      partnerEditModal: {
        data: null,
        isShowPopup: false,
      },
    };
  },
  computed: {
    ...mapGetters([
      "getRoleScopes",
      "getUserAcl",
      "getUserAclv2Menu",
      "getCandidateListUrlBasedOnRole",
      "isJobSupplierFromAccessToken",
      "isSuperCustomer",
      "isServiceProvider",
      "getCustomerTypeIDFromAccessToken",
      "getUser",
      "isPartnerFromAccessToken",
      "getOrgTypeIDFromAccessToken",
      "getPartnerList",
      "getPartnerOrgIdFromAccessToken",
      "isCustomerAdmin",
      "isSystemAdminFromAccessToken",
      "getCustomerId",
      "orgDetailFromAccessToken",
    ]),
    getAcl() {
      const subMenus = {
        jobs: {
          view_edit_job_board: [
            { label: "Active Jobs", menu: "active_jobs", menu_items: [] },
            { label: "Inactive Jobs", menu: "inactive_jobs", menu_items: [] },
            { label: "Archive Jobs", menu: "archive_jobs", menu_items: [] },
          ],
        },
        settings: {
          users: [
            { label: "Add User", menu: "add_user", menu_items: [] },
            { label: "List User", menu: "list_user", menu_items: [] },
          ],
          organisation: [
            {
              label: "Add Organisation",
              menu: "add_organisation",
              menu_items: [],
            },
            {
              label: "List Organisation",
              menu: "list_organisation",
              menu_items: [],
            },
          ],
          config: [
            { label: "Theme and Logo", menu: "theme_and_logo", menu_items: [] },
            {
              label: "Document Library",
              menu: "document_library",
              menu_items: [],
            },
            { label: "Email Config", menu: "email_config", menu_items: [] },
          ],
        },
      };

      const isEducationalInstitute = this.isEducationalInstitute;

      const aclMenus = this.getUserAclv2Menu.map((item) => {
        const menu_group_name =
          isEducationalInstitute && item.menu_group_name === "Candidates"
            ? "Students"
            : item.menu_group_name;

        return {
          label: menu_group_name,
          menu: this.convertToSnackCase(item.menu_group_name),
          menu_items: item.menus.map((subItem) => ({
            label:
              isEducationalInstitute && menu_group_name === "Students"
                ? "Students"
                : subItem.option_name,
            label:
              isEducationalInstitute && menu_group_name === "Students"
                ? "Students"
                : subItem.option_name,
            menu: this.convertToSnackCase(subItem.option_name),
            menu_items:
              menu_group_name === "Students"
                ? []
                : subMenus[this.convertToSnackCase(item.menu_group_name)]?.[
                    this.convertToSnackCase(subItem.option_name)
                  ] || [],
          })),
        };
      });

      // TBD - Hardcoded Courses for demo
      const customer_user_role = this.normalizeKey(
        this.getUser?.users_roles?.[0]?.display_name || "",
      );

      if (
        isEducationalInstitute &&
        customer_user_role === "course_administrator" &&
        !aclMenus.some((item) => item.menu === "courses")
      ) {
        aclMenus.splice(aclMenus.length - 1, 0, {
          label: "Courses",
          menu: "courses",
          disabled: false,
          menu_items: [
            { label: "Add Course", menu: "add_course", menu_items: [] },
            { label: "List Course", menu: "list_course", menu_items: [] },
          ],
        });
        // aclMenus.push({
        //   label: "Courses",
        //   menu: "courses",
        //   disabled: false,
        //   menu_items: [
        //     { label: "Add Course", menu: "add_course", menu_items: [] },
        //     { label: "List Course", menu: "list_course", menu_items: [] },
        //   ],
        // });
      }

      // Readiness Dashboard — always inject for demo
      if (aclMenus.length) {
        const dashboardGroup = aclMenus.find((m) => m.menu === "dashboard");
        const target = dashboardGroup || aclMenus[0];
        if (!target.menu_items.some((i) => i.menu === "readiness_dashboard")) {
          target.menu_items.push({
            label: this.isEducationalInstitute ? "Learner Dashboard" : "Workforce Dashboard",
            menu: "readiness_dashboard",
            menu_items: [],
          });
        }
      }

      return aclMenus;
    },

    isCurrentUserTypeRecruiter() {
      return (
        (this.currentUserType &&
          this.currentUserType.type_name === "job_requisitioner") ||
        false
      );
    },
    currentUserRole() {
      const curRole = this.getRoleScopes.length
        ? this.isCustomerRecruiterUser && !this.isCurrentUserTypeRecruiter
          ? "customer_user"
          : this.getRoleScopes[0]
        : "";
      const roleCheck = {
        customer_recruiter: "customer_recruiter",
        customer_admin: "customer_admin",
      };
      return this.getRoleScopes.length
        ? this.currentUserType?.code
          ? roleCheck[this.currentUserType?.code] || "customer_user"
          : this.getRoleScopes[0]
        : "";
    },
    isEducationalInstitute() {
      return this.getCustomerTypeIDFromAccessToken === 72 || false; // education, was 5
    },
  },
  methods: {
    ...mapActions(["fetchPartners", "updatePartner"]),
    async openUpdateThumbnail() {
      const organisationId = this.getPartnerOrgIdFromAccessToken;
      await this.fetchPartners({
        skip: 0,
        organisation_id: organisationId,
      });
      const currentPartner = this.getPartnerList?.[0];
      this.partnerEditModal.data = currentPartner;
      this.partnerEditModal.isShowPopup = true;
    },
    partnerModalCallBack(action, payload) {
      if (action === false) {
        this.partnerEditModal.isShowPopup = false;
        this.partnerEditModal.data = null;
      } else if (action === true) {
        let appendAction = this.updatePartner(payload);
        Promise.all([appendAction]).then((res) => {
          if (res) {
            this.partnerEditModal.isShowPopup = false;
            this.partnerEditModal.data = null;
          }
        });
      }
    },
    getMenuIcon(menu) {
      switch (menu) {
        case "dashboard":
          return "fas fa-list";
        case "candidates":
          return "fas fa-briefcase-medical";
        case "categories":
          return "fas fa-briefcase-medical";
        case "customers":
          return "fas fa-user-friends";
        case "partners":
          return "fas fa-hospital";
        case "jobs":
          return "fas fa-briefcase";
        case "courses":
          return "fas fa-briefcase";
        case "settings":
          return "fas fa-users-cog";
        case "talentfind":
          return "tfw-icon";
        case "students":
          return "fas fa-graduation-cap";
        case "courses":
          return "fas fa-chalkboard-user";
        case "profile_page":
          return "fas fa-users-cog";
        default:
          return "fas fa-list";
      }
    },
    getSubMenuIcon(menu) {
      switch (menu) {
        case "dashboard":
          return "fas fa-chalkboard-teacher";
        case "advanced_dashboard":
          return "fas fa-chalkboard-teacher";
        case "readiness_dashboard":
          return "fas fa-hospital-alt";
        case "management_report":
          return "fas fa-chart-line";
        case "talent_pool":
          return "fas fa-user-friends";
        case "students":
          return "fas fa-user-friends";
        case "recruitment_status":
          return "fas fa-user-check";
        case "add_customer":
          return "fas fa-user-plus";
        case "customer_list":
          return "fas fa-users";
        case "add_partner":
          return "fas fa-hospital";
        case "partner_list":
          return "fas fa-list";
        case "create_job":
          return "fas fa-laptop-medical";
        case "job_list":
          return "fas fa-list";
        case "allocate_job":
          return "fas fa-briefcase-medical";
        case "programmes":
          return "fas fa-list-alt";
        case "job_templates":
          return "fas fa-list-alt";
        case "add_candidate":
          return "fas fa-user-plus";
        case "onboarding_docs":
          return "fas fa-folder-open";
        case "theme_and_logo":
          return "fas fa-images";
        case "email_template":
          return "fas fa-envelope";
        case "campaign_form":
          return "fas fa-file-pen mr-2";
        case "short_registration":
          return "fa-solid fa-user-pen";
        case "full_registration":
          return "fa-solid fa-user-pen";
        case "public_job_board":
          return "fas fa-briefcase";
        case "full_registered_candidates":
          return "fas fa-user-check";
        case "short_registered_candidates":
          return "fas fa-user";
        case "all_candidates":
          return "fas fa-user-friends";
        case "active_jobs":
          return "fas fa-briefcase";
        case "inactive_jobs":
          return "fas fa-calendar-times";
        case "archive_jobs":
          return "fas fa-square-xmark";
        case "users":
          return "fas fa-user-friends";
        case "add_user":
          return "fas fa-user-plus";
        case "list_user":
          return "fas fa-users";
        case "add_organisation":
          return "fas fa-hospital";
        case "list_organisation":
          return "fas fa-hospital";
        case "theme_and_logo":
          return "fas fa-images";
        case "document_library":
          return "fas fa-folder-open";
        case "email_config":
          return "fas fa-envelope";
        case "config":
          return "fas fa-cog";
        case "organisation":
          return "fas fa-hospital";
        default:
          return "fas fa-list";
      }
    },
    getPathForMenu(menu, item, pathParams = "") {
      let talent_pool_url = this.getCandidateListUrlBasedOnRole;

      if (item?.menu === "talentfind" || this.isSuperCustomer) {
        talent_pool_url = TFW_CANDIDATE_URL;
        if (this.isSuperCustomer) {
          talent_pool_url = TFW_CANDIDATE_URL.replace("/full_registration", "");
        }
      }

      let path = this.getCandidateListUrlBasedOnRole;

      switch (menu) {
        case "system_dashboard":
          path = "/dashboard";
          break;

        case "dashboard":
          path = this.isPartnerFromAccessToken
            ? "/partner-dashboard"
            : "/recruiter-dashboard";
          break;

        case "advanced_dashboard":
          path = "/advanced-dashboard";
          break;

        case "readiness_dashboard":
          path = "/readiness-dashboard";
          break;

        case "management_report":
          path = "/management-report";
          break;

        case "full_registered_candidates":
          path = `${talent_pool_url}/full_registration`;
          break;

        case "short_registered_candidates":
          path = `${talent_pool_url}/short_registration`;
          break;

        case "all_candidates":
          path = `${talent_pool_url}`;
          break;

        case "recruitment_status":
          path = "/job-candidates-status?tabIndex=0&tab=allTab";
          break;

        case "add_customer":
          path = "/add-customer";
          break;

        case "customer_list":
          path = "/customer-list";
          break;

        case "add_partner":
          path = "/add-partner";
          break;

        case "partner_list":
          path = "/partner-list";
          break;

        case "create_job":
          path = "/add-job?step=0";
          break;

        case "job_list":
          path = "/job-list?published=%5B27,28,29%5D";
          break;

        case "allocate_job":
          path = "/job-allocation";
          break;

        case "job_templates":
          path = "/list-job-templates";
          break;

        case "onboarding_docs":
        case "document_library":
          path = "/onboarding-documents";
          break;

        case "campaign_form":
          path = "/campaign-register";
          break;

        case "theme_and_logo":
          path = "/theme-and-logo";
          break;

        case "email_templates":
          path = "/email-templates";
          break;

        case "course_list":
          path = "/list-course";
          break;

        case "create_course":
          path = "/add-course";
          break;

        case "list_course":
          path = "/list-course";
          break;

        case "add_course":
          path = "/add-course";
          break;

        case "customer_template":
          path = "/customer_template";
          break;

        case "profile_page":
          path = "/profile-page";
          break;

        case "add_profile_page":
          path = "/add-profile-page";
          break;
        case "short_registration":
          path = "/add-candidate";
          break;

        case "full_registration":
          path = this.userRegisterLink();
          break;

        case "setup_ai_web_page":
          path = "/setup-ai-web-page";
          break;

        case "public_job_board":
          path = "/config-public-job-board";
          break;

        case "add_user":
          path = "/add-contactuser";
          break;

        case "list_user":
          path = "/list-contactuser";
          break;

        case "talent_pool":
          path = this.isEducationalInstitute
            ? this.getCandidateListUrlBasedOnRole
            : "/candidate-list/super_customer/full_registration";
          break;

        case "candidates":
          path = this.isEducationalInstitute
            ? this.getCandidateListUrlBasedOnRole
            : talent_pool_url;
          break;

        case "active_jobs":
          path = "/jobs-list/status/active";
          break;

        case "inactive_jobs":
          path = "/jobs-list/status/inactive";
          break;

        case "archive_jobs":
          path = "/jobs-list/status/archive";
          break;

        case "add_organisation":
          path = "/add-organisation";
          break;

        case "list_organisation":
          path = "/organisation-list";
          break;

        case "theme_and_logo":
          path = "/theme-and-logo";
          break;

        case "document_library":
          path = "/onboarding-documents";
          break;

        case "email_config":
          path = "/email-templates";
          break;

        default:
          path = "/";
          break;
      }

      if (!pathParams) return path;

      const [basePath, queryString] = path.split("?");
      const finalPath = `${basePath}/${pathParams}`;

      return queryString ? `${finalPath}?${queryString}` : finalPath;
    },
    toggleClass(ref) {
      if (this.$refs[ref] && this.$refs[ref][0]) {
        this.$refs[ref][0].hide(true);
      }
    },
    show(ref) {
      if (this.$refs[ref]) this.$refs[ref][0]._data.visible = true;
    },
    hide(ref) {
      if (this.$refs[ref]) this.$refs[ref][0]._data.visible = false;
    },
    navigateTo(path, ref) {
      this.$refs[ref][0]._data.visible = true;
      return this.$router.push(path);
    },
    userRegisterLink() {
      let { path_acronym, customer_uid, organisation_id, location_id } =
        getLocalOrgDetail();

      let path = `/${path_acronym}/register/${customer_uid}`;
      if (organisation_id) {
        path += `/organisation/${organisation_id}/location/${location_id}`;
      }
      path += `?full-register=true`;
      return path;
    },
    normalizeKey(key) {
      return key.toLowerCase().replace(/\s+/g, "_");
    },
    convertToSnackCase(str) {
      return str.toLowerCase().replaceAll(" ", "_").replaceAll("/", "_");
    },
  },
};
</script>
